import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from './internal/AbstractPolymorphicSerializer.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import {
  SEALED_getInstance19i1cdv1u9v1e as SEALED_getInstance,
  CONTEXTUAL_getInstance20l1ap7hne5we as CONTEXTUAL_getInstance,
} from './descriptors/SerialKinds.mjs';
import { StringCompanionObject_instance2dx16b5pp3v3z as StringCompanionObject_instance } from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { serializer1x79l67jvwntn as serializer } from './builtins/BuiltinSerializers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor } from './descriptors/SerialDescriptors.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { zip2suipyqmdw72q as zip } from '../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { toMap1vec9topfei08 as toMap } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { asList2ho2pewtsfvv as asList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { SerializationStrategyh6ouydnm6hci as SerializationStrategy } from './KSerializer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function SealedClassSerializer$_get_descriptor_$ref_m511rz() {
  return constructCallableReference((p0) => p0.get_descriptor_wjt6a0_k$(), 1, 0, 14);
}
var SealedClassSerializer$$inlined$groupingBy$1Class;
function SealedClassSerializer$$inlined$groupingBy$1() {
  if (SealedClassSerializer$$inlined$groupingBy$1Class === VOID) {
    class $ {
      constructor($this) {
        this.$this_1 = $this;
      }
      sourceIterator_2zqxcn_k$() {
        return this.$this_1.iterator_jk1svi_k$();
      }
      keyOf_qdhuon_k$(element) {
        return element.get_value_j01efc_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
      }
      keyOf_d1fr09_k$(element) {
        return this.keyOf_qdhuon_k$(element);
      }
    }
    initMetadataForClass($);
    SealedClassSerializer$$inlined$groupingBy$1Class = $;
  }
  return SealedClassSerializer$$inlined$groupingBy$1Class;
}
var SealedClassSerializerClass;
function SealedClassSerializer() {
  if (SealedClassSerializerClass === VOID) {
    class $ extends AbstractPolymorphicSerializer() {
      constructor(serialName, baseClass, subclasses, subclassSerializers) {
        return new.target.new_kotlinx_serialization_SealedClassSerializer_2qsta_k$(serialName, baseClass, subclasses, subclassSerializers);
      }
      static new_kotlinx_serialization_SealedClassSerializer_2qsta_k$(serialName, baseClass, subclasses, subclassSerializers) {
        var $this = this.new_kotlinx_serialization_internal_AbstractPolymorphicSerializer_mpc34r_k$();
        $this.baseClass_1 = baseClass;
        $this._annotations_1 = emptyList();
        var tmp = $this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.descriptor$delegate_1 = lazy(tmp_0, () => {
          var tmp = SEALED_getInstance();
          return buildSerialDescriptor(serialName, tmp, [], ($this$buildSerialDescriptor) => {
            $this$buildSerialDescriptor.element$default_ey7ac9_k$('type', serializer(StringCompanionObject_instance).get_descriptor_wjt6a0_k$());
            var tmp = 'kotlinx.serialization.Sealed<' + $this.baseClass_1.get_simpleName_r6f8py_k$() + '>';
            var tmp_0 = CONTEXTUAL_getInstance();
            var elementDescriptor = buildSerialDescriptor(tmp, tmp_0, [], ($this$buildSerialDescriptor) => {
              // Inline function 'kotlin.collections.forEach' call
              // Inline function 'kotlin.collections.iterator' call
              var _iterator__ex2g4s = $this.serialName2Serializer_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
              while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
                var element = _iterator__ex2g4s.next_20eer_k$();
                // Inline function 'kotlin.collections.component1' call
                var name = element.get_key_18j28a_k$();
                // Inline function 'kotlin.collections.component2' call
                var serializer = element.get_value_j01efc_k$();
                $this$buildSerialDescriptor.element$default_ey7ac9_k$(name, serializer.get_descriptor_wjt6a0_k$());
              }
              return Unit_instance;
            });
            $this$buildSerialDescriptor.element$default_ey7ac9_k$('value', elementDescriptor);
            $this$buildSerialDescriptor.annotations_1 = $this._annotations_1;
            return Unit_instance;
          });
        });
        if (!(subclasses.length === subclassSerializers.length)) {
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('All subclasses of sealed class ' + $this.baseClass_1.get_simpleName_r6f8py_k$() + ' should be marked @Serializable');
        }
        $this.class2Serializer_1 = toMap(zip(subclasses, subclassSerializers));
        var tmp_1 = $this;
        // Inline function 'kotlin.collections.groupingBy' call
        var this_0 = $this.class2Serializer_1.get_entries_p20ztl_k$();
        // Inline function 'kotlin.collections.aggregate' call
        var tmp0 = new (SealedClassSerializer$$inlined$groupingBy$1())(this_0);
        // Inline function 'kotlin.collections.mutableMapOf' call
        // Inline function 'kotlin.collections.aggregateTo' call
        var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = tmp0.sourceIterator_2zqxcn_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var e = _iterator__ex2g4s.next_20eer_k$();
          var key = tmp0.keyOf_d1fr09_k$(e);
          var accumulator = destination.get_wei43m_k$(key);
          accumulator == null && !destination.containsKey_aw81wo_k$(key);
          if (!(accumulator == null)) {
            // Inline function 'kotlin.error' call
            var message = "Multiple sealed subclasses of '" + toString($this.baseClass_1) + "' have the same serial name '" + key + "':" + (" '" + toString(accumulator.get_key_18j28a_k$()) + "', '" + toString(e.get_key_18j28a_k$()) + "'");
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
          }
          // Inline function 'kotlin.collections.set' call
          destination.put_4fpzoq_k$(key, e);
        }
        // Inline function 'kotlin.collections.mapValues' call
        // Inline function 'kotlin.collections.mapValuesTo' call
        var destination_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(destination.get_size_woubt6_k$()));
        // Inline function 'kotlin.collections.associateByTo' call
        var _iterator__ex2g4s_0 = destination.get_entries_p20ztl_k$().iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s_0.next_20eer_k$();
          var tmp_2 = element.get_key_18j28a_k$();
          var tmp$ret$17 = element.get_value_j01efc_k$().get_value_j01efc_k$();
          destination_0.put_4fpzoq_k$(tmp_2, tmp$ret$17);
        }
        tmp_1.serialName2Serializer_1 = destination_0;
        return $this;
      }
      get_baseClass_lygw3m_k$() {
        return this.baseClass_1;
      }
      static new_kotlinx_serialization_SealedClassSerializer_bm9rfz_k$(serialName, baseClass, subclasses, subclassSerializers, classAnnotations) {
        var $this = this.new_kotlinx_serialization_SealedClassSerializer_2qsta_k$(serialName, baseClass, subclasses, subclassSerializers);
        $this._annotations_1 = asList(classAnnotations);
        return $this;
      }
      get_descriptor_wjt6a0_k$() {
        var tmp0 = this.descriptor$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('descriptor', 1, tmp, SealedClassSerializer$_get_descriptor_$ref_m511rz(), null);
        return tmp0.get_value_j01efc_k$();
      }
      findPolymorphicSerializerOrNull_o3cszk_k$(decoder, klassName) {
        // Inline function 'kotlin.collections.get' call
        var this_0 = this.serialName2Serializer_1;
        var tmp0_elvis_lhs = (isInterface(this_0, KtMap()) ? this_0 : THROW_CCE()).get_wei43m_k$(klassName);
        return tmp0_elvis_lhs == null ? super.findPolymorphicSerializerOrNull_o3cszk_k$(decoder, klassName) : tmp0_elvis_lhs;
      }
      findPolymorphicSerializerOrNull_sqpvzc_k$(encoder, value) {
        var tmp0_elvis_lhs = this.class2Serializer_1.get_wei43m_k$(getKClassFromExpression(value));
        var tmp1_safe_receiver = tmp0_elvis_lhs == null ? super.findPolymorphicSerializerOrNull_sqpvzc_k$(encoder, value) : tmp0_elvis_lhs;
        var tmp;
        if (tmp1_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlinx.serialization.internal.cast' call
          tmp = isInterface(tmp1_safe_receiver, SerializationStrategy()) ? tmp1_safe_receiver : THROW_CCE();
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'SealedClassSerializer');
    SealedClassSerializerClass = $;
  }
  return SealedClassSerializerClass;
}
//region block: exports
export {
  SealedClassSerializer as SealedClassSerializeriwipiibk55zc,
};
//endregion

//# sourceMappingURL=SealedSerializer.mjs.map
